export default "__VITE_ASSET__DsgfrdxR__"